import { ReactNode, createContext, useCallback, useContext } from 'react'
import { ExtraContentsContext } from './ExtraContentsContext'
import { LessonExtraContentsContext } from './LessonExtraContentsContext'
import { ModulesContext } from './ModulesContext'

interface ICourseContextsResetContext {
  resetAllContexts: () => void
}

export const CourseContextsResetContext =
  createContext<ICourseContextsResetContext>({
    resetAllContexts: () => {},
  })

export function CourseContextsResetProvider({
  children,
}: {
  children: ReactNode
}) {
  const { resetExtraContents } = useContext(ExtraContentsContext)
  const { resetLessonExtraContents } = useContext(LessonExtraContentsContext)
  const { resetModules } = useContext(ModulesContext)

  const resetAllContexts = useCallback(() => {
    resetExtraContents?.()
    resetLessonExtraContents?.()
    resetModules?.()
  }, [resetExtraContents, resetLessonExtraContents, resetModules])

  return (
    <CourseContextsResetContext.Provider value={{ resetAllContexts }}>
      {children}
    </CourseContextsResetContext.Provider>
  )
}
